module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Light-0f6761bed51205c46f1975350c97e787.woff2";